import { PaymentAction } from '@adyen/adyen-web/dist/types/types';
import { PaymentRequestObjectKeys } from './PaymentRequestObjectConstants';
import IPaymentProvider from './IPaymentProvider';
import PaymentComponentConfiguration from './PaymentComponentConfiguration';
import PaymentProviderSubmitResult from './PaymentProviderSubmitResult';

import expandDotNotation from '../utils/form/expandDotNotation';

interface PaymentComponent {
  enable(): void;
  mount(target: string | HTMLElement): Promise<void>;
  submit(): Promise<AuthorizationRequest>;
  updateAmountAsync(amount: number): Promise<string>;
}

interface AuthorizationRequest {
  payload?: string;
  storeCard?: boolean;
  [key: string]: any;
}

class MerchantServicesPaymentProvider implements IPaymentProvider {
  private paymentComponent: PaymentComponent;

  private subscribers: ((result: PaymentProviderSubmitResult) => void)[] = [];

  private additionalRequestData = {};

  private shouldAddToPaymentRequestObject(key: string): boolean {
    return key.startsWith('MobileOptInForm') ||
      PaymentRequestObjectKeys.includes(key);
  }

  getType(): 'MerchantServicesPaymentProvider' {
    return 'MerchantServicesPaymentProvider';
  }

  constructor(config: PaymentComponentConfiguration) {
    this.subscribers = [];
    this.paymentComponent = new TessituraMerchantServices.PaymentComponent({
      ...config,
      onSubmit: (state: any) => {
        if (this.additionalRequestData) {
          state.AdditionalData = {};

          Object.entries(this.additionalRequestData).forEach(([key, value]) => {
            if (this.shouldAddToPaymentRequestObject(key)) {
              state[key] = value;
            } else {
              state.AdditionalData[key] = value;
            }
          });
        }
        this.notifySubscribers(state);
      },
    });
  }

  notifySubscribers(request: AuthorizationRequest, isSubmitted: boolean = false) {
    let subscriber;
    while (subscriber = this.subscribers.pop()) {
      subscriber({
        paymentMethodData: request.payload,
        additionalData: this.additionalRequestData,
        error: null,
        isCancelled: false,
        isSubmitted: isSubmitted,
      });
    }
  }

  additionalAction(action: PaymentAction): void {
  }

  disable(): void {
  }

  enable(): void {
    this.paymentComponent.enable();
  }

  reload($target: HTMLElement | null, clientUpdatedAmount: number): Promise<string> {
    return this.paymentComponent.updateAmountAsync(clientUpdatedAmount);
  }

  async setup($target: string | HTMLElement): Promise<void> {
    return this.paymentComponent.mount($target);
  }

  showValidation(): void {
  }

  async submit(formData: object): Promise<PaymentProviderSubmitResult> {
    this.additionalRequestData = expandDotNotation(formData);
    const promise = this.subscribe();

    try {
      await this.paymentComponent.submit();
      this.notifySubscribers(formData, true);
    } catch (error) {
      this.notifySubscribers({
        error: error
      }, false);
    }

    return promise;
  }

  subscribe() {
    const promise = new Promise<PaymentProviderSubmitResult>((resolve) => {
      this.subscribers.push(resolve);
    });

    return promise;
  }
}

export default MerchantServicesPaymentProvider;
